export default __webpack_public_path__ + "static/media/love-icon.633885a6.svg";